import React from 'react';
import { Space } from 'antd';
import { TwitterIcon, FacebookIcon, YouTubeIcon, LinkedInIcon } from 'components/Icons';
import styled from 'styled-components';

const TwitterIconStyled = styled(TwitterIcon)`
    font-size: 24px;
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const FacebookIconStyled = styled(FacebookIcon)`
    font-size: ${({ size }) => size};
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const YoutubeIconStyled = styled(YouTubeIcon)`
    font-size: ${({ size }) => size};
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const LinkedInIconStyled = styled(LinkedInIcon)`
    font-size: ${({ size }) => size};
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

interface Props extends SocialLinks {
    size?: string;
}

const SocialLinks = ({ twitter, facebook, linkedin, youtube, size = '24px' }: Props) => (
    <Space size="middle">
        {facebook && (
            <a target="_blank" href={facebook} rel="noopener noreferrer">
                <FacebookIconStyled size={size} />
            </a>
        )}
        {twitter && (
            <a target="_blank" href={twitter} rel="noopener noreferrer">
                <TwitterIconStyled />
            </a>
        )}
        {linkedin && (
            <a target="_blank" href={linkedin} rel="noopener noreferrer">
                <LinkedInIconStyled size={size} />
            </a>
        )}
        {youtube && (
            <a target="_blank" href={youtube} rel="noopener noreferrer">
                <YoutubeIconStyled size={size} />
            </a>
        )}
    </Space>
);

export default SocialLinks;
